<template>
  <v-container class="point-balance" v-if="currentUser">
    <v-row class="account-info-title">
      <v-col class="text-left">
        <h3>{{ $t('my_account.point_balance') }}: {{ currentUser.point_balance }}</h3>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="$router.push({name: 'top-up-init'})">{{ $t('my_account.topup') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-menu ref="datePickerMenu"
                v-model="datePickerMenuOpened"
                :close-on-content-click="false"
                transition="scale-transition"
                bottom>
          <template v-slot:activator="{on, attrs}">
            <v-text-field outlined
                          v-model="selectedMonth"
                          append-icon="mdi-calendar"
                          readonly
                          hide-details
                          v-on="on"></v-text-field>
          </template>
          <v-date-picker type="month"
                         no-title
                         scrollable
                         v-model="selectedMonth"
                         @input="datePickerMenuOpened = false">
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table :items="transactions"
                      :headers="headers">
          <template v-slot:item.create_at="{value}">
            {{ fromISO(value).toFormat('yyyy-MM-dd') }}
          </template>
          <template v-slot:item.type="{value}">
            {{ $t(`point_transaction_type.${value}`) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ref, onMounted, computed, watch} from '@vue/composition-api';
import {DateTime} from 'luxon';

export default {
  name: 'PointBalance',
  setup(props, {root}) {
    const currentUser = computed(() => {
      return root.$store.state.user;
    });

    const datePickerMenuOpened = ref(false);
    const selectedMonth = ref(DateTime.fromJSDate(new Date()).toFormat('yyyy-MM'));
    const selectedMonthStart = computed(() => {
      return DateTime.fromISO(selectedMonth.value).startOf('month').toSeconds();
    });
    const selectedMonthEnd = computed(() => {
      return DateTime.fromISO(selectedMonth.value).endOf('month').toSeconds();
    });

    const headers = ref([
      {text: root.$t('point_transaction.create_at'), value: 'create_at'},
      {text: '', value: 'type'},
      {text: root.$t('point_transaction.amount'), value: 'amount'},
    ])
    const transactions = ref([]);

    const getTransactions = function () {
      root.$callAPI('aafb/point/', {
        from_date: selectedMonthStart.value,
        to_date: selectedMonthEnd.value,
      }, function (response) {
        transactions.value = response.body.records;
      });
    };

    watch(() => selectedMonth.value, () => {
      getTransactions();
    })

    onMounted(() => {
      getTransactions();
    })


    return {
      currentUser,

      datePickerMenuOpened,
      selectedMonth,


      headers,
      transactions,
      getTransactions,

      fromISO: DateTime.fromISO,
    }
  }
}
</script>
